import { Input } from 'antd';
import { ArgsTypeWithCustomKeys } from './calculatorsTypes';
import { EkaFocosableElement } from '../../../common/types/EkaFocusable';

export const CalculatorInput: React.FC<{
    arg: ArgsTypeWithCustomKeys;
    onInputChange: (
        name: string,
        value: string | undefined,
        type?: 'unitSwitchers' | 'valueSelects',
    ) => void;
    setPropertyInputRef: (
        ref: EkaFocosableElement | Input | null,
        index: number,
        subIndex: number,
    ) => void;
    index: number;
    handleNextFocus: (index: number, subIndex: number) => void;
}> = ({ arg, onInputChange, setPropertyInputRef, index, handleNextFocus }) => {
    return (
        <Input
            type={'number'}
            value={arg?.inputValue || ''}
            ref={(ref) => {
                setPropertyInputRef(ref, index, 0);
            }}
            onPressEnter={() => handleNextFocus(index + 1, 0)}
            onChange={(e) => {
                arg?.inputValue !== e.target.value &&
                    onInputChange(arg?.name, e.target.value || undefined);
            }}
            allowClear
            className={'border-none'}
        />
    );
};
